import { useRef, useState } from 'react';

// Centralizes the "show a message, auto-hide after a few seconds" toast
// pattern that used to be duplicated (inconsistently — some call sites also
// scheduled their own extra setTimeout) across App.tsx. Each notify() call
// (re)starts the auto-hide countdown, so a rapid second toast doesn't get
// cut off by the first toast's timer.
export interface UseToastResult {
  toastMessage: string;
  showToast: boolean;
  notify: (message: string) => void;
}

const TOAST_VISIBLE_MS = 3000;

export function useToast(): UseToastResult {
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const notify = (message: string): void => {
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    setToastMessage(message);
    setShowToast(true);
    hideTimerRef.current = setTimeout(() => setShowToast(false), TOAST_VISIBLE_MS);
  };

  return { toastMessage, showToast, notify };
}
